
// src/components/checagens/ChecagemKPI.tsx
import React from 'react';
import { useChecagemProgresso } from '../../hooks/useChecagens';
import './ChecagemKPI.css';

interface ChecagemKPIProps {
  checagemId: number;
}

const ChecagemKPI: React.FC<ChecagemKPIProps> = ({ checagemId }) => {
  const { data: progresso, isLoading, error } = useChecagemProgresso(checagemId);

  if (isLoading) return <div className="kpi-loading">Carregando...</div>;
  if (error) return null; // Don't show anything on error

  const progress = Math.round(progresso?.progresso_medio || 0);

  return (
    <div className="checagem-kpi">
      <div className="progress-bar-container">
        <div 
          className="progress-bar-filler"
          style={{ width: `${progress}%` }}
        ></div>
      </div>
      <span className="progress-text">{progress}%</span>
    </div>
  );
};

export default ChecagemKPI;
